var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"m-4"},[_c('img',{staticClass:"align-self-center brand-default",attrs:{"src":this.$store.getters['platform/logo'],"alt":"platform-logo","height":"100"}})]),_c('div',{staticClass:"swagger",attrs:{"id":"swagger"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }